// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__gaq2F","container":"styles_container__dh4NT","slide":"styles_slide__Rs1Hv"};